/**
 * Action types for VLAN Pool functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_VLAN_POOL = 'GET_VLAN_POOL';
export const GET_VLAN_POOL_SUCCESS = 'GET_VLAN_POOL_SUCCESS';
export const GET_VLAN_POOL_FAIL = 'GET_VLAN_POOL_FAIL';
export const DELETE_VLAN_POOL = 'DELETE_VLAN_POOL';
export const DELETE_VLAN_POOL_SUCCESS = 'DELETE_VLAN_POOL_SUCCESS';
export const DELETE_VLAN_POOL_FAIL = 'DELETE_VLAN_POOL_FAIL';
export const ADD_VLAN_POOL = 'ADD_VLAN_POOL';
export const ADD_VLAN_POOL_COMPLETE =  'ADD_VLAN_POOL_COMPLETE';
export const EDIT_VLAN_POOL = 'EDIT_VLAN_POOL'
export const EDIT_VLAN_POOL_COMPLETE =  'EDIT_VLAN_POOL_COMPLETE'